import React from "react";

const ProjectsPlaceholder = () => {
    return (
      <section className="flex flex-col w-auto mb-5">
        <h3 className="mt-0 lg:mt-4 mb-5 px-1 lg:px-5 font-bold text-xl">PROJECTS</h3>
        <div className="mx-1 lg:mx-5 p-10 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200 text-center">
          <p className="text-slate-600 italic font-medium">
            "Currently leading a full-scale data transformation. 
            I look forward to sharing my high-level methodologies and architectural frameworks once the dust settles!"
          </p>
        </div>
      </section>
    )
}

export default ProjectsPlaceholder;
